import React, { FC, useContext } from 'react';
import { Button, ButtonSize, ButtonTheme } from '../../../shared/common/Button';
import { ShowAllContext } from '../../../shared/subscription-management/ShowAllContext';
import { ManageSubscriptionsHeader } from '../../../shared/subscription-management/types/ManageSubscriptionsHeader';
import { useTranslation } from 'react-i18next';

export const ManageRenewalTableHeader: FC<ManageSubscriptionsHeader> = ({
    showAllLabel,
    currentYearSubscriptionPeriodLabel,
    nextYearSubscriptionPeriodLabel
}) => {
    const { ref } = useContext(ShowAllContext);
    const { t } = useTranslation();
    return (
        <thead>
            <tr>
                <th colSpan={2}>
                    {showAllLabel ? (
                        <Button
                            ref={ref}
                            text={t('shop.subscriptions.showAllCopies')}
                            theme={ButtonTheme.NEUTRAL}
                            className="gild"
                            onClick={() => {}}
                            size={ButtonSize.MEDIUM}
                        />
                    ) : null}
                </th>
                <th className="current-year-subscriptions">
                    <h5>{t('shop.subscriptions.currentYearSubscriptions')}</h5>
                    <div>{currentYearSubscriptionPeriodLabel}</div>
                </th>
                <th className="previous-issue-usage">
                    <h5>{t('shop.subscriptions.previousIssueUsage')}</h5>
                </th>
                <th className="current-issue-usage">
                    <h5>{t('shop.subscriptions.currentIssueUsage')}</h5>
                </th>
                <th className="next-year-subscriptions">
                    <h5>{t('shop.subscriptions.nextYearSubscriptions')}</h5>
                    <div>{nextYearSubscriptionPeriodLabel}</div>
                </th>
                <th className="copies-to-order">
                    <h5>{t('shop.subscriptions.copiesToOrder')}</h5>
                </th>
                <th className="renewal-total">
                    <h5>{t('shop.subscriptions.total')}</h5>
                </th>
            </tr>
        </thead>
    );
};
